module.exports = __webpack_public_path__ + "static/media/12.200486a9.png";